import { render, staticRenderFns } from "./pos-products-addcats.vue?vue&type=template&id=de689d18"
import script from "./pos-products-addcats.vue?vue&type=script&lang=js"
export * from "./pos-products-addcats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports